module.exports = "/_next/static/images/817b7512b321712a40f7d464498a99b1-credit-card-autonomy@2x.png";